import { render, staticRenderFns } from "./DateMotherCare.vue?vue&type=template&id=01507390&scoped=true"
import script from "./DateMotherCare.vue?vue&type=script&lang=js"
export * from "./DateMotherCare.vue?vue&type=script&lang=js"
import style0 from "./DateMotherCare.vue?vue&type=style&index=0&id=01507390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01507390",
  null
  
)

export default component.exports